export const columns: any = [{
  title: 'select-all-btn',
  colSize: '6',
  active: false,
  col: 'select-btn'
},
{
  title: 'Schedule name',
  sortable: false,
  active: false,
  colSize: '17',
  col: 'name',
  columnName: 'name',
  truncate: true,
},
{
  title: 'Date Created',
  sortable: false,
  active: false,
  colSize: '12',
  col: 'created_at',
  columnName: 'created_at',
  truncate: true,
},
{
  title: 'Price Sheets',
  sortable: false,
  active: false,
  col: 'export_data.priceSheetNumbers',
  colSize: '17',
  columnName: 'export_data.priceSheetNumbers',
  truncate: false,
},
{
  title: 'Frequency',
  sortable: false,
  active: false,
  col: 'frequency',
  colSize: '5',
  columnName: 'frequency',
  truncate: true,
},
];
